import React from "react";
import PropTypes from "prop-types";
import "./ImageElement.css";
import Image from "./Image";
import ItemTypes from "../../../../../../constants/ItemTypes";

function calculatePosition(props) {
  let position = {};
  if (props.noOffset) {
    return position;
  }
  const scale = 72 * props.design.preview_scale;
  // TODO check on use_color_mask, layer_mask, use_product_mask are used

  // CONVERT FROM INCHES TO PIXELS
  position.top = props.imageElement.top_position * scale;
  position.left = props.imageElement.left_position * scale;

  if (props.offsetX) {
    position.left -= props.offsetX;
  }
  if (props.offsetY) {
    position.top -= props.offsetY;
  }
  return position;
}

class ImageElement extends React.Component {
  imageUrl() {
    // Get rotation and other properties needed for image URL
    const layer = this.props.design.layer_set[this.props.layerId];
    let color = layer.print_color;
    if (layer.print_color_from_layer !== "") {
      let fromLayer = this.props.design.layer_set[layer.print_color_from_layer];
      if (layer.print_color_type === "Paper") {
        color = fromLayer.color;
      } else {
        color = fromLayer.print_color;
      }
    }

    const color_id = color ? color.id : "24",
      embossed = layer.is_embossed ? 1 : 0,
      repousse = layer.is_repousse ? 1 : 0;

    const style = `&embossed=${embossed}&repousse=${repousse}`;

    let url = process.env.REACT_APP_TEXT_EFFECTS_URL;

    // Force rotation to be a number between 0-360
    let rotation = Number(this.props.imageElement.rotation) || 0;

    // Ensure rotation is a valid integer
    rotation = Math.round(rotation);

    // Keep rotation in 0-360 range
    if (rotation < 0) rotation = 360 + (rotation % 360);
    if (rotation >= 360) rotation = rotation % 360;

    if (this.props.imageElement.clipart) {
      url += `clipart?id=${this.props.imageElement.clipart.id}&color_id=${color_id}&size=${this.props.imageElement.size}&rotation=${rotation}&scale=${this.props.design.preview_scale}${style}`;
    } else if (this.props.imageElement.userart) {
      url += `userart/${this.props.imageElement.userart.id}?color_id=${color_id}&size=${this.props.imageElement.size}&rotation=${rotation}&type=${this.props.imageElement.type}&scale=${this.props.design.preview_scale}${style}`;
    }

    return url;
  }

  render() {
    const url = this.imageUrl();

    return (
      <div className="image-element" style={calculatePosition(this.props)}>
        <Image
          index={this.props.index}
          layerId={this.props.layerId}
          url={url}
          imageElement={this.props.imageElement}
          itemType={ItemTypes.IMAGE}
          disableInteractivity={this.props.disableInteractivity}
          handleIsResizing={this.props.handleIsResizing}
          onShow2ndTip={this.props.onShow2ndTip}
          didShow2ndTip={this.props.didShow2ndTip}
          handleHide2ndTip={this.props.handleHide2ndTip}
          layer={this.props.layer}
        />
      </div>
    );
  }
}

ImageElement.propTypes = {
  layerId: PropTypes.number.isRequired,
  imageElement: PropTypes.object.isRequired,
  design: PropTypes.object.isRequired
};
export default ImageElement;
